import '../../style/index.less';
import './index.less';



// WEBPACK FOOTER //
// ./components/divider/style/index.tsx